import { createAsyncThunk } from '@reduxjs/toolkit';
import { getResidencesByGroup, getServersByGroup, getSyncHistory, getSyncHistoryDetail, GriResidence, GriServer, postResidenceSync, putResidence, putServer } from 'services/api';

export const getResidencesByGroupAsync = createAsyncThunk(
  'resiplusIntegration/getResidencesByGroup',
  async (groupId: string) => {
    const response = await getResidencesByGroup(groupId);
    const payload = response.data.data;
    if (Array.isArray(payload)) return payload;
    if (payload && typeof payload === 'object') return [payload];
    return [];
  },
);

export const postResidenceSyncAsync = createAsyncThunk(
  'resiplusIntegration/postResidenceSync',
  async (residenceId: string) => {
    const response = await postResidenceSync(residenceId);
    return response.data;
  },
);

export const getServersByGroupAsync = createAsyncThunk(
  'resiplusIntegration/getServersByGroup',
  async (groupId: string) => {
    const response = await getServersByGroup(groupId);
    const payload = response.data.data as any;
    if (payload?.content && Array.isArray(payload.content)) return payload.content;
    if (Array.isArray(payload)) return payload;
    if (payload && typeof payload === 'object') return [payload];
    return [];
  },
);

export const putResidenceAsync = createAsyncThunk(
  'resiplusIntegration/putResidence',
  async (residence: GriResidence) => {
    const response = await putResidence(residence);
    return response.data.data;
  },
);

export const putServerAsync = createAsyncThunk(
  'resiplusIntegration/putServer',
  async (server: GriServer) => {
    const response = await putServer(server);
    return response.data.data;
  },
);

export const getSyncHistoryAsync = createAsyncThunk(
  'resiplusIntegration/getSyncHistory',
  async ({ residenceId, page = 0, size = 20 }: { residenceId: string; page?: number; size?: number }) => {
    const response = await getSyncHistory(residenceId, page, size);
    const payload = response.data.data as any;
    // Spring Page envelope
    if (payload?.content && Array.isArray(payload.content)) return payload.content;
    if (Array.isArray(payload)) return payload;
    return [];
  },
);

export const getSyncHistoryDetailAsync = createAsyncThunk(
  'resiplusIntegration/getSyncHistoryDetail',
  async (id: string) => {
    const response = await getSyncHistoryDetail(id);
    return response.data.data;
  },
);
